import React from 'react'
import SettingShippingRuleContext from '../context/SettingShippingRuleContext'
import PropTypes from 'prop-types'

function SettingShippingRuleProvider(props) {
    const {loadShippingRules, setState, filters} = props

    return (
        <SettingShippingRuleContext.Provider
            value={{
                reLoadShippingRules: loadShippingRules,
                filters,
                setState: setState
            }}
        >
            {props.children}
        </SettingShippingRuleContext.Provider>
    )
}

SettingShippingRuleProvider.propTypes = {
    loadShippingRules: PropTypes.func.isRequired
}

export default SettingShippingRuleProvider
